import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from './lib/utils';

/**
 * Dismissible chip showing an active filter value.
 *
 * <FilterChip label="Status: Active" onDismiss={() => setStatus('all')} />
 *
 * Use inside FilterBar to surface active filters as removable tags.
 */
function FilterChip({ label, onDismiss, className, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 h-6 pl-2.5 pr-1.5 rounded-full',
        'text-[11px] font-medium text-aqua bg-aqua-glow border border-aqua/20',
        className
      )}
      {...props}
    >
      {label}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={`Remove filter: ${label}`}
          className="rounded-full hover:bg-aqua/20 transition-colors p-0.5"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}

/**
 * "Clear all" text link — shown when any filter is non-default.
 *
 * <FilterClear onClick={handleClear} count={2} />
 */
function FilterClear({ onClick, count, className, ...props }) {
  if (!count) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'text-caption font-body text-text-muted hover:text-red-critical transition-colors underline-offset-2 hover:underline',
        className
      )}
      {...props}
    >
      Clear{count > 1 ? ` (${count})` : ''}
    </button>
  );
}

export { FilterChip, FilterClear };
